{
    "locale": "no-NO",
    "General": {
        "OrText": "Eller",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Gå til My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Opprett ny konto",
        "ButtonText_SignInToYourAccount": "Logg inn på kontoen din",
        "ButtonText_StartInterviewWithoutSigningUp": "Start intervju uten å registrere deg",
        "ButtonText_StartInterviewWithoutSigningIn": "Start intervju uten å logge inn",
        "Navlink_Dashboard": "Oversikt",
        "Navlink_MyInterviews": "Mine intervjuer",
        "Navlink_LearnWithHubert": "Lær med Hubert",
        "Navlink_HelpCenter": "Hjelpesenter",
        "MyProfile": "Min profil",
        "LogOut": "Logg ut"
    },
    "Login": {
        "MainTitle": "Se resultatene av Hubert-intervjuet ditt",
        "Subtitle": "Logg inn for å se resultater, få tilbakemelding, lese råd og mye mer.",
        "LoginTitle": "Logg inn på Hubert-kontoen din",
        "Label_Email": "E-post",
        "Label_Password": "Passord",
        "ButtonText_SignIn": "Logg inn",
        "ButtonText_ForgotPassword": "Glemt passord?",
        "ButtonText_ContinueWithGoogle": "Fortsett med Google",
        "OrSeparator": "Eller",
        "Error_Email_Required": "E-post er påkrevd.",
        "Error_Email_Invalid": "Skriv inn en gyldig e-post.",
        "Error_Password_Required": "Passord er påkrevd.",
        "Error_Use_Same_Email_As_Interview": "Vennligst bruk den samme e-posten du oppga i intervjuet."
    },
    "Registration": {
        "MainTitle": "Se resultatene av Hubert-intervjuet ditt",
        "Subtitle": "Registrer deg for å se resultater, få tilbakemelding, lese råd og mye mer.",
        "RegistrationTitle": "Opprett Hubert-konto",
        "BenefitsBox_Title": "Du kan",
        "BenefitsBox_Point1": "Få tilgang til intervjuhistorikken din",
        "BenefitsBox_Point2": "Få tilbakemelding på intervjuene dine",
        "BenefitsBox_Point3": "Gjenbruke svar i nye intervjuer",
        "BenefitsBox_Point4": "Få intervjuråd",
        "BenefitsBox_Point5": "Lese karriereguider",
        "BenefitsBox_Point6": "Og mye mer",
        "Label_FirstName": "Fornavn",
        "Label_LastName": "Etternavn",
        "Label_Email": "E-post",
        "Label_Password": "Passord",
        "Label_PhoneNumber": "Telefonnummer",
        "Label_TermsOfService": "Jeg godtar",
        "Label_TermsOfServiceLink": "Personvernerklæring og Vilkår og betingelser",
        "Placeholder_CountryCode": "Velg landskode",
        "Placeholder_PhoneNumber": "F.eks.91234567",
        "HelpText_Password": "Passordet må være minst 6 tegn langt.",
        "ButtonText_SignUp": "Registrer deg",
        "ButtonText_SignUpWithGoogle": "Registrer deg med Google",
        "OrSeparator": "Eller",
        "Error_FirstName_Required": "Fornavn er påkrevd.",
        "Error_LastName_Required": "Etternavn er påkrevd.",
        "Error_Email_Required": "E-post er påkrevd.",
        "Error_Email_Invalid": "Skriv inn en gyldig e-post.",
        "Error_Email_Exists": "E-posten er allerede i bruk.",
        "Error_Password_Required": "Passord er påkrevd.",
        "Error_Password_6_Characters": "Passordet ditt må være minst 6 tegn langt.",
        "Error_PhoneNumber_Required": "Telefonnummer er påkrevd.",
        "Error_PhoneNumber_Invalid": "Telefonnummeret er ikke gyldig.",
        "Error_PrivacyPolicyCheck_Required": "Du må godta Personvernerklæring og Vilkår og betingelser."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "For å ta intervjuet må du godta vilkårene for bruk av Hubert. Bare kryss av i boksen for å fortsette.",
        "Subtitle_AfterInterviewCompleted": "Registrer deg for å se resultater, få tilbakemelding, lese råd og mye mer.",
        "PrivacyPolicyText": "Ved å trykke på registrer deg godtar du",
        "PrivacyPolicyLink": "Personvernerklæring og Vilkår og betingelser",
        "ButtonText_SignUp": "Registrer deg og gå til intervju",
        "ButtonText_SignUpNormal": "Registrer deg",
        "ButtonText_SignInInstead": "Klikk her for å logge inn i stedet"
    },
    "LoginInviteEmail": {
        "Subtitle": "Logg inn for å se resultater, få tilbakemelding, lese råd og mye mer."
    },
    "AppMessages": {
        "internal-server-error": "Uventet feil oppstod.",
        "invalid-credentials": "Ugyldige påloggingsdetaljer. Vennligst prøv igjen.",
        "user-not-found": "Ugyldige påloggingsdetaljer. Vennligst prøv igjen.",
        "account-not-found": "Ugyldig konto. Vennligst prøv igjen.",
        "verify-email-title": "Bekreft e-posten din",
        "verify-email-subtitle": "Vennligst sjekk e-posten din for å bekrefte kontoen.",
        "email-not-verified-title": "E-post ikke bekreftet",
        "email-not-verified-subtitle": "Vennligst sjekk e-posten din for å bekrefte kontoen.",
        "verifying-email-title": "Bekrefter e-post",
        "verifying-email-subtitle": "Vennligst vent...",
        "sign-in-title": "Logger inn",
        "sign-in-subtitle": "Vennligst vent...",
        "server-error": "Noe gikk galt.",
        "hubert-user-exists": "Kontoen finnes allerede.",
        "account-exists": "Kontoen finnes allerede.",
        "email-verified": "E-posten din er bekreftet.",
        "email-is-taken": "E-posten er allerede i bruk.",
        "re-enter-password": "Bruk passordet ditt for å logge inn",
        "password-reset": "Passordet ditt er endret.",
        "re-enter-new-password": "Bruk det nye passordet ditt for å logge inn",
        "invalid-invitation": "Ugyldig invitasjon.",
        "invalid-code": "Ugyldig verifiseringskode.",
        "email-already-verified": "E-posten er allerede bekreftet.",
        "email-mismatch-title": "E-post samsvarer ikke",
        "email-mismatch-subtitle": "Vennligst bruk den samme e-postadressen du brukte da du søkte på jobben."
    },
    "TransitionPage": {
        "loading-title": "Laster...",
        "loading-subtitle": "Forbereder dataene dine...",
        "logout-title": "Laster...",
        "logout-subtitle": "Du logges ut..."
    },
    "ImpersonationPage": {
        "loading-title": "Laster...",
        "loading-subtitle": "Forbereder dataene dine..."
    },
    "ProcessInvitation": {
        "loading-title": "Laster...",
        "loading-subtitle": "Vent litt mens vi laster intervjuet ditt.",
        "InvitationNotFound": "Vi finner ikke intervjuet ditt.",
        "InvitationExpired": "Denne lenken for å få tilgang til intervjuet har utløpt.",
        "InvitationExpired_Description1": "Vennligst åpne intervjuet fra.",
        "InvitationExpired_Description2": "eller kontakt rekruttereren din.",
        "InvitationInvalid": "Lenken til denne invitasjonen er ugyldig.",
        "InterviewCompleted": "Dette intervjuet er allerede fullført."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Mine intervjuer",
            "TableHead_Employer": "Arbeidsgiver",
            "TableHead_Job": "Stilling",
            "TableHead_Status": "Status",
            "TableHead_ApplicationDate": "Søknadsdato",
            "TableBody_StartInterview": "Intervjuet er ikke fullført. Klikk her for å starte eller fortsette intervjuet.",
            "TableBody_NotScored": "Intervjuet er fullført. Resultatene vil være tilgjengelige snart.",
            "TableBody_Details": "Klikk her for å se intervjuresultater og mer.",
            "ApplicationDate_Invited": "Invitert",
            "ApplicationDate_MinuteAgo": "minutt siden",
            "ApplicationDate_MinutesAgo": "minutter siden",
            "ApplicationDate_HourAgo": "time siden",
            "ApplicationDate_HoursAgo": "timer siden",
            "ApplicationDate_DayAgo": "dag siden",
            "ApplicationDate_DaysAgo": "dager siden",
            "ButtonText_SeeAllInterviews": "Se alle intervjuer",
            "ButtonText_Details": "Detaljer",
            "ButtonText_StartInterview": "Gå til intervju",
            "ButtonText_NotScored": "Venter på resultater",
            "NoInterviews_Message": "Det finnes ingen registreringer av tidligere eller kommende intervjuer for deg."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Det er ingen stillingsutlysninger akkurat nå. Sjekk igjen senere."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Min karriere",
            "Subtitle": "Velg intervjuet for å se vurderingen og dine muligheter.",
            "MostRecentInterview": "Siste intervju",
            "ToDo": "Å gjøre",
            "NoOngoingInterviews_Title": "Du har ingen nye intervjuinvitasjoner.",
            "NoOngoingInterviews_Subtitle": "Nye Hubert-intervjuer vil vises her når de er planlagt av rekrutterere.",
            "NoRecentInterviews_Title": "Det finnes ingen tidligere intervjuer registrert for deg.",
            "NoRecentInterviews_Subtitle": "Når du blir invitert til et intervju av en rekrutterer, vil det vises nedenfor.",
            "ButtonText_StartInterview": "Gå til intervju",
            "ButtonText_NotScored": "Venter på resultat",
            "ButtonText_Details": "Detaljer"
        },
        "LearnWithHubert": {
            "Title": "Lær med Hubert",
            "Subtitle": "Få råd om hvordan du forbedrer deg i intervjuer og på jobb.",
            "PickedForMe": "Siste artikler",
            "ButtonText_SeeAllArticles": "Se alle artikler"
        },
        "HubertTip": {
            "Title": "Hubert-tips",
            "Subtitle": "Ta intervjuer raskere",
            "Description": "Søker du på en ny jobb i en lignende rolle som du allerede har tatt et Hubert-intervju for? Du kan gjenbruke svarene dine og spare tid.",
            "ButtonText_ReadMoreTips": "Les flere tips"
        },
        "NewCandidateModalPopup": {
            "Title": "Alt klart!",
            "DescriptionLine1": "Kontoen din er nå klar.",
            "DescriptionLine2": "Administrer intervjuer og profil. Se resultater, få tilbakemelding og lær mer om hvordan du gjennomfører intervjuer.",
            "ButtonText_LetsGo": "La oss starte"
        },
        "InterviewCompletedModal": {
            "Title": "Godt jobbet!",
            "Subtitle": "Du har fullført intervjuet.",
            "Description": "Rekrutterere vil gjennomgå alle søknader og gi tilbakemelding via e-post eller telefon så snart de har en oppdatering.",
            "ButtonText_Continue": "Fortsett"
        },
        "LatestJobPostings": {
            "Title": "Siste jobbannonser",
            "Subtitle": "Utforsk nylig publiserte stillinger fra Huberts partnere."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Mine intervjuer",
        "MyInterviewsSection_Subtitle": "Velg intervjuet for å se vurderingen og dine karrieremuligheter.",
        "MyInterviewsSection_ToDo": "Å gjøre"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Se alle intervjuer",
        "InterviewNotFound_Title": "Intervju ikke tilgjengelig",
        "InterviewNotFound_Description": "Du prøver å få tilgang til detaljer for et intervju som ikke er knyttet til kontoen din.",
        "ButtonText_GoToAllInterviews": "Gå til Mine intervjuer",
        "InterviewDetails": {
            "Title": "Intervjudetaljer",
            "ForRole": "For stilling",
            "InterviewCompletedOn": "Intervju fullført den {{date}} kl. {{time}}"
        },
        "MyResult": {
            "Title": "Mitt resultat",
            "Subtitle": "Vurdert samsvar",
            "ButtonText_LearnMore": "Se hvordan svarene dine vurderes",
            "GotPotential_Title": "Sterkt potensial, ett krav kom ikke tydelig frem",
            "GotPotential_Description": "Svarene dine gir et godt inntrykk for denne typen rolle. I dette intervjuet kom ett eller flere krav for stillingen ikke tydelig frem i svarene dine. For å styrke vurderingen, legg til konkrete bevis, som sertifikat, antall år, eller et kort eksempel som viser at du oppfyller kravet. Dette er ikke et endelig svar på om du passer eller ikke. Ofte handler det om hvor tydelig svarene dine treffer behovene i akkurat denne rollen. Se tipsene nedenfor for å gjøre krav, eksempler og resultater mer konkrete.",
            "GotPotential_DescriptionSecondary": "Huberts vurdering er rådgivende. Rekruttereren tar den endelige beslutningen, og andre faktorer, som antall søkere, spiller også inn.",
            "GreatMatch_Title": "Sterk match",
            "GreatMatch_Description": "Svarene dine samsvarer godt med det rekrutterere vanligvis ser etter i denne rollen, og kravene ser ut til å være oppfylt. Rekruttereren går gjennom alle kandidater og bestemmer neste steg.",
            "GreatMatch_DescriptionSecondary": "Huberts vurdering er rådgivende. Rekruttereren tar den endelige beslutningen, og andre faktorer, som antall søkere, spiller også inn. Dette er ikke et endelig svar på om du passer eller ikke. Ofte handler det om hvor tydelig svarene dine treffer behovene i akkurat denne rollen. Se tipsene nedenfor for å gjøre krav, eksempler og resultater mer konkrete.",
            "OkMatch_Title": "Kvalifisert, styrk eksemplene dine",
            "OkMatch_Description": "Du ser ut til å oppfylle kravene for stillingen. For å skille deg ut kan det hjelpe å være mer konkret, med ett eksempel og et tydelig resultat. Se gjennom svarene dine nedenfor og finn steder der du kan tydeliggjøre hva du gjorde og hva som ble resultatet.",
            "OkMatch_DescriptionSecondary": "Huberts vurdering er rådgivende. Rekruttereren tar den endelige beslutningen, og andre faktorer, som antall søkere, spiller også inn.",
            "NotClearMatch_Title": "Kanskje ikke en full match (ennå)",
            "NotClearMatch_Description": "Basert på dette intervjuet er samsvaret med rollen uklart, eller ett eller flere krav kan være ubekreftet. Start med spørsmålene nedenfor og gjør svarene dine mer konkrete, med ett eksempel, tydelige handlinger og et resultat.",
            "NotClearMatch_DescriptionSecondary": "Huberts vurdering er rådgivende. Rekruttereren tar den endelige beslutningen, og andre faktorer, som antall søkere, spiller også inn."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Erfaring, motivasjon og kompetanse",
            "QualifyingRequirements": "Krav for denne stillingen",
            "NotQualified_Title": "Rom for forbedring",
            "NotQualified_Description": "Svarene dine kan ha virket litt for generelle, eller lite resultatorienterte, sammenlignet med det rekruttereren forventer i denne rollen. Se nedenfor etter steder der et eksempel, handlinger du gjorde, eller et tydelig resultat kan gjøre svaret sterkere.",
            "GreatResults_Title": "Sterke svar",
            "GreatResults_Description": "Svarene dine tyder på at du passer godt til denne typen rolle og kommuniserte tydelig. Hvis et spørsmål kan forbedres, blir det markert nedenfor.",
            "MeetingRequirements_Title": "Oppfyller kravene",
            "MeetingRequirements_Description": "Svarene dine tyder på at du oppfyller kravene rekruttereren har satt for denne stillingen. Godt utgangspunkt.",
            "NotAllExpectationsMet_Title": "Ett eller flere krav er ikke bekreftet",
            "NotAllExpectationsMet_Description": "Basert på svarene dine er ett eller flere krav ikke bekreftet, for eksempel sertifikater, lisenser, utdanning eller antall år med erfaring. Hvis du oppfyller kravet, legg det inn konkret i svaret ditt, med dokumentasjon eller et kort eksempel.",
            "ButtonText_FindOutPossibleReasons": "Se detaljer"
        },
        "ScriptFromInterview": {
            "Title": "Les hele intervjuet",
            "ButtonText_SeeWholeTranscript": "Les intervjuet",
            "ButtonText_DeleteInterview": "Slett intervjuet",
            "Loading_Title": "Laster...",
            "Loading_Subtitle": "Vent litt mens vi laster inn intervjuutskriften din."
        },
        "HowToImproveAtInterviews": {
            "Title": "Slik blir du bedre i intervjuer",
            "Subtitle_Questions": "Her er noen spørsmål der svaret ditt potensielt kan bli bedre.",
            "Subtitle_NoQuestions": "Ingen svar ble markert. Her er tips for å gjøre krav, eksempler og resultater tydeligere i denne typen rolle.",
            "GreatMatch_Questions_Description": "Selv om du virker som en sterk match, kan noen svar fortsatt styrkes. Hvis vi har identifisert slike, finner du dem nedenfor. Følg instruksjonene før hvert spørsmål. Når du beskriver en situasjon, ta med situasjonen, hva du gjorde og resultatet. Unngå veldig korte svar. Sikt på tydelige og konkrete beskrivelser.",
            "GreatMatch_NoQuestions_Description": "Svarene dine var tydelige og konkrete. Fortsett å bruke korte, relevante eksempler og et tydelig resultat.",
            "OkMatch_Questions_Description": "Nedenfor finner du spørsmål der svaret ditt kan bli bedre. Følg instruksjonene før hvert spørsmål. Når du beskriver en situasjon, ta med situasjonen, hva du gjorde og resultatet. Unngå veldig korte svar. Sikt på tydelige og konkrete beskrivelser.",
            "OkMatch_NoQuestions_Description": "Svarene dine var solide, men denne rollen kan være konkurransepreget. Da kan selv gode svar havne i midten.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Neste gang, fokuser på tydelighet og tyngde. Start med resultatet, legg til ett ekte eksempel og hold det kort, vanligvis 3 til 6 setninger. Vær konkret på hva du gjorde, hvordan du gjorde det og hva som endret seg som følge av det.",
            "GotPotential_Questions_Description": "Selv om du virker som en sterk match for denne typen jobb, kan noen svar fortsatt styrkes. Hvis vi har identifisert slike, finner du dem nedenfor. Følg instruksjonene før hvert spørsmål. Når du beskriver en situasjon, ta med situasjonen, hva du gjorde og resultatet. Unngå veldig korte svar. Sikt på tydelige og konkrete beskrivelser.",
            "GotPotential_NoQuestions_Description": "Vi fant ingen svar som trenger stor forbedring når det gjelder kompetanse og motivasjon. Likevel kan ett eller flere krav være uklare, fordi de ikke kom tydelig frem i intervjuet.",
            "NotClearMatch_Questions_Description": "Nedenfor finner du spørsmål der svaret ditt kan bli bedre. Følg instruksjonene før hvert spørsmål. Når du beskriver en situasjon, ta med situasjonen, hva du gjorde og resultatet. Unngå veldig korte svar. Sikt på tydelige og konkrete beskrivelser.",
            "NotClearMatch_NoQuestions_Description": "Vi fant ikke ett enkelt svakt svar. Det handler mer om total samsvar med det rollen trenger. Hvis konkurransen er sterk, kan små gap ha betydning.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Til neste intervju, vær konkret. Velg ett eksempel per spørsmål, forklar handlingene dine og del resultatet. Kort og spesifikt slår ofte langt og generelt.",
            "Alert_WantMoreAdvice": "Vil du ha flere tips for å prestere godt i et Hubert-intervju?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Se vår generelle tipsartikkel"
        },
        "SimilarOffers": {
            "Title": "Lignende stillinger"
        },
        "HowHubertScoresInterviews": {
            "Title": "Hvordan vurderer Hubert intervjuer?",
            "Description": "Her forklarer vi hva Hubert vurderer i intervjusvar, og hva de ulike resultatene betyr. Under Rekrutteringsprosess ser du også vanlige neste steg etter et Hubert-intervju.",
            "Tabs_PossibleOutcomes": "Mulige utfall",
            "Tabs_RecruitmentProcess": "Rekrutteringsprosess",
            "AssessedMatch_Title": "Vurdert samsvar",
            "AssessedMatch_Description": "Hubert oppsummerer hvor tydelig svarene dine dekker det rekruttereren ser etter i rollen, basert på spørsmålene og kravene som er satt. Du vil se ett av resultatene nedenfor.",
            "AssessedMatch_DescriptionSecondary": "Huberts vurdering er rådgivende. Rekruttereren tar den endelige beslutningen, og andre faktorer, som antall søkere, spiller også inn.",
            "GreatMatch_Title": "Sterk match",
            "GreatMatch_Description": "Svarene dine samsvarer godt med rekruttererens forventninger, og kravene ser ut til å være oppfylt. Rekruttereren går gjennom alle kandidater og bestemmer neste steg.",
            "GotPotential_Title": "Sterkt potensial, ett krav kom ikke tydelig frem",
            "GotPotential_Description": "Svarene dine viser sterkt potensial for denne typen rolle. Ett eller flere krav kom ikke tydelig frem, eller er ikke bekreftet i svarene dine. Det kan påvirke neste steg, avhengig av rekruttererens behov. Hvis du har kravet, sørg for at det nevnes konkret, med dokumentasjon eller et eksempel.",
            "OkMatch_Title": "Kvalifisert, styrk eksemplene dine",
            "OkMatch_Description": "Du ser ut til å oppfylle kravene. For å skille deg ut kan du gjøre svarene dine mer konkrete, med ett eksempel og et tydelig resultat.",
            "NotClearMatch_Title": "Kanskje ikke en full match (ennå)",
            "NotClearMatch_Description": "Basert på dette intervjuet er samsvaret med rollen uklart, eller ett eller flere krav kan være ubekreftet. Se gjennom svarene dine og legg til konkrete eksempler, handlinger og resultater.",
            "ProfessionalExperiences_Title": "Erfaring, motivasjon og kompetanse",
            "ProfessionalExperiences_Description": "Dette er spørsmål om dine tidligere erfaringer, din motivasjon for jobben og kompetansen som er relevant for rollen. Rekrutterere bestemmer hvilke spørsmål som brukes.",
            "GreatResults_Title": "Sterke svar",
            "GreatResults_Description": "Svarene dine tyder på at du passer godt til denne typen rolle og kommuniserte tydelig. Hvis et spørsmål kan forbedres, blir det markert.",
            "NotQualified_Title": "Rom for forbedring",
            "NotQualified_Description": "Svarene dine kan ha virket litt for generelle. Se etter markerte steder der et eksempel, handlinger du gjorde, eller et tydelig resultat kan gjøre svaret sterkere.",
            "QualifyingRequirements_Title": "Grunnleggende krav for denne stillingen",
            "QualifyingRequirements_Description": "Dette er spørsmål som rekruttereren har satt som krav for jobben. Det kan for eksempel være et sertifikat, førerkort eller en viss grad av erfaring.",
            "MeetingRequirements_Title": "Oppfyller kravene",
            "MeetingRequirements_Description": "Svarene dine indikerer at du oppfyller kravene som rekruttereren har satt. Godt utgangspunkt.",
            "NotAllExpectationsMet_Title": "Ett eller flere krav er ikke bekreftet",
            "NotAllExpectationsMet_Description": "Basert på svarene dine er ett eller flere krav ikke bekreftet, for eksempel sertifikater, lisenser, utdanning eller år med erfaring. Hvis du oppfyller kravet, sørg for at det kommer tydelig frem i svaret ditt.",
            "RecruitmentProcess_Title": "Rekrutteringsprosess",
            "RecruitmentProcess_Description": "Hubert brukes ofte som et tidlig steg i en rekrutteringsprosess med mange kandidater. Det gir alle mulighet til å svare på de samme spørsmålene og dele relevant erfaring. Vurderingen bygger på svarene dine, ikke på personlige kjennetegn som alder, kjønn eller utseende. Dette kan bidra til en mer konsistent første vurdering.",
            "EventOne_Title": "Du blir intervjuet av Hubert",
            "EventOne_Description": "Du tar intervjuet når og hvor det passer deg best. Det er vanligvis ingen tidsbegrensning, og du kan ta en pause når som helst.",
            "EventTwo_Title": "Intervjuet ditt vurderes",
            "EventTwo_Description": "Svarene dine vurderes, og resultatet blir synlig her i My Hubert og hos rekruttereren når vurderingen er klar.",
            "EventThree_Title": "Rekruttereren velger kandidater",
            "EventThree_Description": "Rekruttereren får beskjed når et resultat er tilgjengelig. De går gjennom svarene dine og Huberts vurdering, og bestemmer neste steg, for eksempel en telefonsamtale, en test eller et siste intervju. Noen ganger venter de til flere søknader er kommet inn. Hvis andre kandidater passer bedre for behovet akkurat nå, kan neste steg bli et annet.",
            "ButtonText_Close": "Lukk"
        }
    },
    "MyProfile": {
        "Title": "Min profil",
        "MyDetails": {
            "Title": "Mine detaljer",
            "Label_FirstName": "Fornavn",
            "Label_LastName": "Etternavn",
            "Label_Email": "E-post",
            "Label_PhoneNumber": "Telefonnummer",
            "ButtonText_UpdateDetails": "Oppdater detaljer",
            "Error_FirstName_Required": "Fornavn er påkrevd.",
            "Error_LastName_Required": "Etternavn er påkrevd.",
            "Error_Email_Required": "E-post er påkrevd.",
            "Error_Email_Invalid": "Skriv inn en gyldig e-post.",
            "Error_PhoneNumber_Invalid": "Telefonnummeret er ikke gyldig.",
            "Success_Details_Updated": "Profil oppdatert."
        },
        "ChangePassword": {
            "Title": "Endre passord",
            "Set_Password_Title": "Lag passord",
            "Label_CurrentPassword": "Nåværende passord",
            "Label_NewPassword": "Nytt passord",
            "Label_RepeatNewPassword": "Gjenta nytt passord",
            "Alert_SignInAgain": "Vennligst logg inn igjen for å sette passordet ditt.",
            "ButtonText_UpdatePassword": "Oppdater passord",
            "ButtonText_SetPassword": "Sett passord",
            "ButtonText_SignInAgain": "Logg inn igjen",
            "Error_CurrentPassword_Required": "Nåværende passord er påkrevd.",
            "Error_CurrentPassword_DoesntMatch": "Passordet stemmer ikke med nåværende passord.",
            "Error_NewPassword_Required": "Nytt passord er påkrevd.",
            "Error_NewPassword_6_Characters": "Ditt nye passord må være minst 6 tegn langt.",
            "Error_RepeatNewPassword_Required": "Gjenta nytt passord er påkrevd.",
            "Error_RepeatNewPassword_DoesntMatch": "Passordet stemmer ikke med nytt passord.",
            "Success_Password_Changed": "Passordet ble oppdatert.",
            "Error_Invalid_CurrentPassword": "Ugyldig nåværende passord."
        },
        "NotificationPreferences": {
            "Title": "Varslingspreferanser",
            "Label_ReceiveUpdatesToggle": "Jeg vil motta Hubert-oppdateringer.",
            "Label_ReceiveUpdatesToggleHelpText": "Du vil få karriereveiledning, intervjutips og mer."
        },
        "AccountRemoval": {
            "Title": "Sletting av konto",
            "ButtonText_RemoveMyAccount": "Slett min konto"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Hallo",
        "Subtitle": "Du er i ferd med å starte jobbintervjuet.",
        "TipBox_Title": "Her er noen tips for å lykkes.",
        "TipBox_Tip1": "Gjør intervjuet på et rolig sted hvor du kan konsentrere deg.",
        "TipBox_Tip2": "Bruk en datamaskin med tastatur (med mindre du er komfortabel med å skrive mye på mobil).",
        "TipBox_Tip3": "Vær så spesifikk og detaljert som mulig. Hubert og rekrutterere ønsker å bli kjent med deg.",
        "TipBox_Tip4": "Ta den tiden du trenger. Det er ingen tidsbegrensninger.",
        "TipBox_Tip5": "Du kan ta en pause når som helst og fortsette der du slapp.",
        "TipBox_Tip6": "Vær deg selv og gå til Hubert-intervjuet med samme seriøsitet som et intervju med en person.",
        "CheckAdviceArticle_Text1": "Hvis du ønsker flere tips om hvordan du lykkes med intervjuet, sjekk ut denne",
        "CheckAdviceArticle_Text2": "artikkelen",
        "CheckAdviceArticle_Text3": "med gode råd.",
        "ReadyToGetStarted": "Er du klar til å komme i gang?",
        "ORSeparator_Text": "Eller",
        "ButtonText_StartInterviewNow": "Start intervjuet",
        "ButtonText_SetReminder": "Ikke klar, sett en påminnelse",
        "PrivacyPolicyText": "Ved å trykke start intervju godtar du",
        "PrivacyPolicyLink": "Personvernerklæring og Vilkår og betingelser"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Godt jobbet!",
        "CompletedAlert_Subtitle": "Du har fullført intervjuet.",
        "CompletedAlert_Description": "Rekrutterere vil gjennomgå alle søknader og gi tilbakemelding via e-post eller telefon så snart de har en oppdatering.",
        "InterviewNotCompleted": "Dette intervjuet er ikke fullført."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Hjelpesenter",
            "Subtitle": "Finn svarene på de mest stilte spørsmålene om Hubert.",
            "Label_Search": "søk etter vanlige spørsmål",
            "ButtonText_Search": "Søk"
        },
        "FAQSection": {
            "Tabs_All": "Alle",
            "Tabs_AboutHubertInterview": "Om Hubert-intervjuet",
            "Tabs_TechnicalSupport": "Teknisk støtte"
        },
        "StillHaveQuestion": {
            "Title": "Har du fortsatt et spørsmål?",
            "Description": "Vi hjelper gjerne.",
            "DropUsAEmail": "Send oss en e-post på hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Kan jeg gjennomføre intervjuet via telefon i stedet?",
                    "a": "Hubert fungerer kun via chat for øyeblikket. Hvis du har en medisinsk tilstand som hindrer deg i å ta intervjuet, vennligst ta direkte kontakt med selskapet."
                },
                {
                    "q": "Kan jeg ta intervjuet på et annet språk?",
                    "a": "For noen intervjuer kan du velge språk ved start. Hvis valget mangler, er språket sannsynligvis et krav. Kontakt selskapet for spørsmål."
                },
                {
                    "q": "Vil jeg bli straffet for å gi korte svar?",
                    "a": "Nei, så lenge du svarer passende. Detaljer hjelper imidlertid ofte."
                },
                {
                    "q": "Kan jeg bruke svarene mine fra et annet intervju med Hubert?",
                    "a": "Ja, hvis du er logget inn på My Hubert og søker på en lignende rolle."
                },
                {
                    "q": "Vil et menneske lese intervjuet mitt?",
                    "a": "Ja, kundene våre blir bedt om å manuelt sjekke intervjuene."
                },
                {
                    "q": "Jeg har gjort intervjuet, hva skjer nå?",
                    "a": "Resultatene sendes til rekruttereren. De ser gjennom svarene og vurderingen, og bestemmer neste steg (telefon, test, intervju)."
                },
                {
                    "q": "Jeg har et spørsmål om neste steg i prosessen, hvem skal jeg kontakte?",
                    "a": "Vennligst ta kontakt med selskapet der du søkte på jobben."
                },
                {
                    "q": "Hvordan sørger dere for at dere ikke introduserer skjevhet i rekrutteringsprosessen?",
                    "a": "Hubert er konsekvent og kjenner ikke til kjønn, alder eller utseende, noe som reduserer vanlige skjevheter."
                },
                {
                    "q": "Kan jeg bli intervjuet av et menneske i stedet for Hubert?",
                    "a": "Ta kontakt med selskapet der du søkte for å spørre om dette."
                },
                {
                    "q": "Er Hubert et menneske?",
                    "a": "Nei, Hubert er et datasystem."
                },
                {
                    "q": "Kan jeg endre svarene mine i etterkant?",
                    "a": "Nei, akkurat som i et ekte intervju, kan du ikke endre svarene etterpå."
                },
                {
                    "q": "Hvordan lykkes jeg i Hubert-intervjuet?",
                    "a": "Les spørsmålene nøye, følg instruksjonene, gi ekte eksempler og vær ærlig."
                },
                {
                    "q": "Jeg trenger en jobb, hvem skal jeg kontakte?",
                    "a": "Kontakt selskapet der du søkte."
                },
                {
                    "q": "Jeg har gjennomført intervjuet, men har ikke hørt noe siden. Hva bør jeg gjøre?",
                    "a": "Rekrutterere bestemmer veien videre. Hvis andre kandidater passer bedre akkurat nå, kan det hende at du ikke går videre til neste steg. Kontakt rekruttereren hvis du ønsker en oppdatering."
                },
                {
                    "q": "Jeg har mye erfaring, men jeg fikk ikke jobben? Hvorfor?",
                    "a": "Konkurransen kan være hard. Kontakt selskapet for tilbakemelding, eller sjekk My Hubert for råd."
                },
                {
                    "q": "Hvor lang tid tar intervjuet?",
                    "a": "Mellom 10 og 25 minutter. Ikke stress."
                },
                {
                    "q": "Hvor kan jeg lese om hvordan dataene mine håndteres?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Hvorfor kan jeg ikke se mine tidligere Hubert-intervjuer?",
                    "a": "Sørg for at du brukte samme e-post som i søknaden (gjelder også Google-pålogging)."
                },
                {
                    "q": "Hvorfor mottok jeg ikke en e-post for intervjuet mitt?",
                    "a": "Sjekk spam-mappen. Eller opprett en My Hubert-konto med søknads-e-posten for å finne lenken."
                },
                {
                    "q": "Jeg finner ikke lenken til intervjuet mitt i e-posten.",
                    "a": "Sjekk spam. Eller logg inn på My Hubert og se under 'Mine intervjuer'."
                },
                {
                    "q": "Fungerer intervjuet på mobile enheter?",
                    "a": "Ja, men en datamaskin er ofte bedre å skrive på."
                },
                {
                    "q": "Intervjuet fungerer ikke, hva skal jeg gjøre?",
                    "a": "Send oss en e-post på hubert@hubert.ai, så hjelper vi deg."
                },
                {
                    "q": "Jeg vil slette hele kontoen min på My Hubert, hva bør jeg gjøre?",
                    "a": "Send en e-post til hubert@hubert.ai."
                },
                {
                    "q": "Intervjuet ble avbrutt, hvordan kan jeg gå tilbake til intervjuet?",
                    "a": "Klikk på lenken i e-posten eller logg inn på My Hubert."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Lær med Hubert",
            "Subtitle": "Finn ut hvordan du øker sjansene dine og presterer bedre på jobb.",
            "Label_Search": "søk i guider",
            "ButtonText_Search": "Søk"
        },
        "TabSelector": {
            "MyFeed": "Min feed",
            "InterviewGuides": "Intervjuguider",
            "CareerGuides": "Karriereguider"
        },
        "NewestOnTheFeed": "Nyeste",
        "PickedForMe": "Siste artikler",
        "InterviewGuides": "Intervjuguider",
        "CareerGuides": "Karriereguider"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Tilbake til alle artikler"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Tilbakestill passord",
        "ResetLinkAlert_Subtitle": "Klikk på lenken sendt til din e-post for å sette et nytt passord.",
        "PasswordNotSetAlert_Message": "Passord ikke satt, logg inn med ",
        "ResetYourPassword": {
            "MainTitle": "Se resultatene av Hubert-intervjuet ditt",
            "Subtitle": "Logg inn for å se resultater, få tilbakemelding og mer.",
            "FormSectionTitle": "Tilbakestill passord",
            "Label_NewPassword": "Nytt passord",
            "Label_ConfirmNewPassword": "Bekreft nytt passord",
            "Error_NewPassword_Required": "Skriv inn et nytt passord.",
            "Error_Password_6_Characters": "Passordet må være minst 6 tegn langt.",
            "Error_ConfirmNewPassword_Required": "Du må bekrefte passordet.",
            "Error_ConfirmNewPassword_NotMatch": "Passordene samsvarer ikke.",
            "Error_MalformedResetUrl": "Ugyldig kode. Prøv igjen.",
            "Error_ResetPasswordFailed": "Problem med tilbakestilling. Prøv igjen.",
            "Error_WeakPassword": "Passordet må ha minst 6 tegn.",
            "Error_InvalidCode_Title": "Forespørselen er utløpt eller ugyldig.",
            "Error_InvalidCode_Subtitle": "Prøv å tilbakestille passordet på nytt.",
            "ButtonText_SetNewPassword": "Sett passord og logg inn",
            "ButtonText_RememberYourPassword": "Husker du passordet?",
            "ButtonText_SignInInstead": "Logg inn i stedet"
        }
    },
    "PageNotFound": {
        "Title": "Side ikke funnet",
        "Description": "Vi finner ikke siden du leter etter.",
        "ButtonText_GoToDashboard": "Gå til oversikt",
        "ButtonText_GoToLogin": "Gå til innlogging"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Gjenbruk av svar er ikke tilgjengelig for dette intervjuet ennå. Vi forventer at det blir tilgjengelig snart, men du kan ta intervjuet nå.",
        "DescriptionLine2": "Gå til intervjuet ved å klikke på knappen nedenfor.",
        "ButtonText_TakeMeToTheInterview": "Gå til intervju"
    },
    "UnsubscribeFromEmails": {
        "Title": "Er du sikker?",
        "Subtitle": "Du vil slutte å motta e-poster om denne jobben:",
        "SelectTheReason": "Velg en årsak.",
        "ReasonText1": "Jeg har funnet en annen jobb.",
        "ReasonText2": "Jeg er ikke lenger interessert.",
        "ReasonText3": "Annet",
        "ButtonText_Unsubscribe": "Meld av",
        "Placeholder_YourReason": "Din årsak",
        "Success_Title": "Du er meldt av e-poster for denne jobben.",
        "Loading": "Laster...",
        "Error_YourReason_Required": "Oppgi en årsak.",
        "Error_ServerIssue": "Avmelding feilet på grunn av serverfeil."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Prøv igjen"
    },
    "Outreach": {
        "CandidateNotFound": "Kandidat ikke funnet",
        "CandidateNotFoundDesc": "Vi fant ikke intervjudetaljene du leter etter.",
        "InterviewEnded": "Intervju avsluttet",
        "InterviewEndedDesc1": "Denne intervjuøkten er avsluttet eller er ikke lenger tilgjengelig.",
        "InterviewEndedDesc2": "Takk for din tid. Hvis du har spørsmål, vennligst kontakt rekrutteringsteamet.",
        "ReadyTitle": "Er du klar for intervjuet ditt, {{firstName}}?",
        "InvitationDesc": "Hubert inviterer deg på vegne av {{companyName}} til et chat-basert intervju som tar omtrent 1-2 minutter å fullføre.",
        "Button_StartChat": "Start chattintervju",
        "CancelNotice": "Start her vil avbryte den planlagte samtalen for denne rollen.",
        "PreferNotToContinue": "Ønsker du ikke å fortsette?",
        "DeclineLabel": "Jeg er ikke interessert i denne rollen. Ikke ring eller send meg meldinger igjen om denne stillingen.",
        "Button_ConfirmAndDecline": "Bekreft og avslå",
        "Processing": "Behandler...",
        "Toast_DeclineSuccess": "Intervjuet ble avslått",
        "Toast_CancelVoiceInfo": "Taleintervju avbrutt. Funksjonen kommer snart.",
        "Toast_CancelError": "Kunne ikke avbryte intervjuet. Vennligst prøv igjen.",
        "Footer_WithdrawConsent": "Du kan når som helst trekke tilbake samtykket ditt. Les mer i ",
        "Footer_PrivacyPolicySuffix": "s personvernerklæring",
        "Footer_And": " og ",
        "Footer_HubertPrivacyLink": "Huberts personvernerklæring og vilkår & betingelser",
        "Chat_InterviewWith": "Intervju med {{companyName}}",
        "Chat_StatusConnected": "Tilkoblet",
        "Chat_StatusError": "Feil",
        "Chat_StatusDisconnected": "Frakoblet",
        "Chat_StatusConnecting": "Kobler til...",
        "Chat_ReadyToStart": "Klar til å starte intervjuet?",
        "Chat_ButtonStart": "Start intervju",
        "Chat_SayHello": "Si hei for å starte samtalen.",
        "Chat_EmptyState": "Send en melding for å starte intervjuet.",
        "Chat_SelectLanguage": "Velg språk",
        "Chat_Placeholder": "Skriv meldingen din...",
        "Chat_ButtonSend": "Send",
        "Chat_ButtonBack": "Tilbake",
        "LoadingCandidateDetails": "Laster kandidatdetaljer...",
        "FetchingCandidateDetails": "Henter kandidatdetaljer...",
        "Chat_StatusReady": "Venter på å koble til...",
        "Chat_ForbiddenError": "Dette chattintervjuet er ikke lenger tilgjengelig.",
        "Chat_GeneralError": "Kunne ikke starte chatten. Vennligst prøv igjen senere.",
        "Chat_SelectUiLanguage": "Språk i menyen",
        "Chat_InterviewTitle": "Jobbintervju"
    }
}
